export const sliceName = 'institutionsPrograms'

export const allTagName = 'Все разделы рубрики'

export const institutionProgramsLimit = 20
